// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de formation historique, géographique, économique et sociale
// https://ifpc-fwb.be/v5/documents/tc/refFHGES.pdf
// SHA-256 71d50efd3a1683c56b8c09121777055e0b2711b3335eafe60487367da1f220f5
// P3: pages 82-83, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "FHGES-P3-29e3e3e7",
    champ: "",
    section: "SE SITUER, SE DÉPLACER, SITUER, LOCALISER UN LIEU, UN FAIT…",
    kind: "Savoir",
    parent: "Le quartier, le village : une partie de la commune.",
    text: "Nommer la commune à laquelle appartient le quartier ou le village.",
  },
  {
    id: "FHGES-P3-7da81c96",
    champ: "",
    section: "SE SITUER, SE DÉPLACER, SITUER, LOCALISER UN LIEU, UN FAIT…",
    kind: "Savoir",
    parent: "Des éléments remarquables de l’occupation du sol à l’échelle de la commune dont un cours d’eau.",
    text: "Identifier des éléments remarquables de l’occupation du sol à l’échelle de la commune.",
  },
  {
    id: "FHGES-P3-b75de9e4",
    champ: "",
    section: "SE SITUER, SE DÉPLACER, SITUER, LOCALISER UN LIEU, UN FAIT…",
    kind: "Savoir",
    parent: "Des éléments remarquables de l’occupation du sol à l’échelle de la commune dont un cours d’eau.",
    text: "Nommer le cours d’eau du milieu observé.",
  },
  {
    id: "FHGES-P3-9ee8a6c9",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir",
    parent: "Principales fonctions à l’échelle d’une commune et occupations du sol caractéristiques : - fonction résidentielle : par exemple, maison/immeuble à appartements, immeubles jointifs, habitat en lotissement ou le long des routes, maison 4 façades ;",
    text: "Associer une occupation/utilisation du sol à une fonction.",
  },
  {
    id: "FHGES-P3-59c208fb",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir",
    parent: "Principales fonctions à l’échelle d’une commune et occupations du sol caractéristiques : - fonction résidentielle : par exemple, maison/immeuble à appartements, immeubles jointifs, habitat en lotissement ou le long des routes, maison 4 façades ;",
    text: "Illustrer une fonction à l’aide d’un exemple d’occupation du sol.",
  },
  {
    id: "FHGES-P3-7ed7d045",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir-faire",
    parent: "Lire un paysage.",
    text: "Annoter une photo prise au sol pour mettre en évidence les occupations/utilisations du sol caractéristiques d’une fonction du milieu observé.",
  },
  {
    id: "FHGES-P3-d92b1958",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir-faire",
    parent: "Lire un croquis cartographique, un plan, une carte.",
    text: "Annoter un plan ou une carte pour mettre en évidence des éléments remarquables ou des occupations du sol caractéristiques d’une fonction à l’échelle locale.",
  },
  {
    id: "FHGES-P3-5ea9e53c",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir-faire",
    parent: "Annoter/construire une représentation de l’espace.",
    text: "Annoter une vue verticale ou un plan pour mettre en évidence une occupation/utilisation du sol caractéristique d’une fonction.",
  },
  {
    id: "FHGES-P3-05a70a44",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Savoir-faire",
    parent: "Annoter/construire une représentation de l’espace.",
    text: "Positionner des éléments observés sur le terrain sur un plan ou sur une vue verticale.",
  },
  {
    id: "FHGES-P3-0d71ddf2",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Compétence",
    parent: "Utiliser des repères spatiaux et/ou des représentations de l’espace pour (se) situer/se déplacer/(s’)orienter.",
    text: "Sur la base d’observations sur le terrain, d’une vue verticale ou d’un plan, situer une occupation/utilisation du sol caractéristique d’une fonction par rapport à des éléments remarquables et en précisant le nom du quartier ou du village et de la commune.",
  },
  {
    id: "FHGES-P3-9f0c3567",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Compétence",
    parent: "Caractériser un paysage/environnement pour contextualiser un fait/phénomène.",
    text: "Sur la base d’une observation sur le terrain ou d’une image géographique, décrire un paysage en faisant référence à l’occupation/utilisation du sol.",
  },
  {
    id: "FHGES-P3-e9364718",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Compétence",
    parent: "Caractériser un paysage/environnement pour contextualiser un fait/phénomène.",
    text: "Sur la base d’images géographiques au sol ou verticales ou de représentations de l’espace actuelles et d’il y a une centaine d’années maximum, identifier des transformations/permanences dans l’occupation/ utilisation du sol à l’échelle locale.",
  },
  {
    id: "FHGES-P3-18e80250",
    champ: "",
    section: "À LA POPULATION ET À L’ORGANISATION DE L’ESPACE",
    kind: "Compétence",
    parent: "Établir des liens entre des composantes spatiales pour expliquer des localisations, des répartitions/ dynamiques spatiales.",
    text: "Sur la base d’une observation sur le terrain ou d’une image géographique, associer une fonction à une occupation dominante du sol observée à l’échelle locale.",
  },
];
